//Sets the state of year to the value of click event
export const handleYear = (e, setYear) => {
    setYear(e.target.value)
}
